/* Metal Memory : champ « Référence RAL » et case obligatoire « exclusion du droit de rétractation » (art. 8.4 CGV) pour la finition Custom.
   Délégation au niveau du document : fonctionne sur la fiche produit, la barre sticky et le quick-add. */
(function () {
  if (window.__mmRalField) return;
  window.__mmRalField = true;

  var MSG_EMPTY = "Merci d'indiquer votre référence RAL (ex. RAL 3020) pour la finition Custom.";
  var MSG_FORMAT = 'Référence RAL non reconnue : indiquez au moins le numéro, par exemple 3020 ou RAL 3020.';
  var MSG_ACK = "Pour la finition Custom, merci de cocher la case ci-dessus : elle confirme que vous avez pris connaissance de l'absence de droit de rétractation.";

  function isCustomValue(v) {
    return /^\s*custom/i.test(v || '');
  }

  function scopeHasPicker(el) {
    var node = el;
    while (node && node !== document.documentElement) {
      if (node.querySelector && node.querySelector('variant-picker')) return node;
      node = node.parentElement;
    }
    return null;
  }

  function isCustomSelected(wrapper) {
    var scope = scopeHasPicker(wrapper);
    if (!scope) return wrapper.getAttribute('data-initial-custom') === 'true';
    var picker = scope.querySelector('variant-picker');
    var checked = picker.querySelectorAll('fieldset input:checked, select option:checked');
    if (!checked.length) return wrapper.getAttribute('data-initial-custom') === 'true';
    for (var i = 0; i < checked.length; i++) {
      if (isCustomValue(checked[i].value)) return true;
    }
    return false;
  }

  function normalise(value) {
    var m = /^\s*(?:ral)?\s*[-:]?\s*(\d{4})\s*$/i.exec(value || '');
    return m ? 'RAL ' + m[1] : (value || '').trim();
  }

  function msg(key, fallback) {
    var el = document.querySelector('[data-mm-ral][' + key + ']');
    var v = el && el.getAttribute(key);
    return v || fallback;
  }

  function validity(value) {
    var v = (value || '').trim();
    if (!v) return msg('data-msg-empty', MSG_EMPTY);
    if (!/\d{3,}/.test(v)) return msg('data-msg-format', MSG_FORMAT);
    return '';
  }

  function parts(wrapper) {
    return {
      input: wrapper.querySelector('[data-mm-ral-input]'),
      error: wrapper.querySelector('[data-mm-ral-error]'),
      ack: wrapper.querySelector('[data-mm-ack]'),
      ackError: wrapper.querySelector('[data-mm-ack-error]'),
      component:
        wrapper.closest('product-form-component') ||
        (function () {
          var i = wrapper.querySelector('[data-mm-ral-input]');
          return i && i.form ? i.form.closest('product-form-component') : null;
        })(),
    };
  }

  function showError(wrapper, message) {
    var p = parts(wrapper);
    if (!p.error || !p.input) return;
    if (message) {
      p.error.textContent = message;
      p.error.hidden = false;
      p.input.setAttribute('aria-invalid', 'true');
    } else {
      p.error.textContent = '';
      p.error.hidden = true;
      p.input.removeAttribute('aria-invalid');
    }
  }

  function showAckError(wrapper, message) {
    var p = parts(wrapper);
    if (!p.ack || !p.ackError) return;
    if (message) {
      p.ackError.textContent = message;
      p.ackError.hidden = false;
      p.ack.setAttribute('aria-invalid', 'true');
    } else {
      p.ackError.textContent = '';
      p.ackError.hidden = true;
      p.ack.removeAttribute('aria-invalid');
    }
  }

  function ackMessage(wrapper) {
    var p = parts(wrapper);
    if (!p.ack || p.ack.disabled || p.ack.checked) return '';
    return msg('data-msg-ack', MSG_ACK);
  }

  function updateAckValidity(wrapper) {
    var p = parts(wrapper);
    if (!p.ack) return '';
    var m = ackMessage(wrapper);
    p.ack.setCustomValidity(m);
    return m;
  }

  function updateValidity(wrapper) {
    var p = parts(wrapper);
    if (!p.input) return '';
    var msg = p.input.disabled ? '' : validity(p.input.value);
    p.input.setCustomValidity(msg);
    return msg;
  }

  function sync(wrapper) {
    var p = parts(wrapper);
    if (!p.input) return;
    var active = isCustomSelected(wrapper);
    wrapper.hidden = !active;
    p.input.disabled = !active;
    p.input.required = active;
    if (p.component) p.component.classList.toggle('mm-ral-active', active);
    if (p.ack) {
      p.ack.disabled = !active;
      p.ack.required = active;
      if (!active) {
        p.ack.checked = false;
        showAckError(wrapper, '');
      }
      updateAckValidity(wrapper);
    }
    if (!active) showError(wrapper, '');
    updateValidity(wrapper);
  }

  // Intitulé de l'option (ex. « Finition Blanc – RAL 9016 ») : toujours la valeur réellement sélectionnée,
  // immédiatement au clic (sans attendre le rendu de section), au chargement (?variant=) et au retour arrière.
  function syncLabels() {
    var sets = document.querySelectorAll('variant-picker fieldset');
    for (var i = 0; i < sets.length; i++) {
      var label = sets[i].querySelector('legend .variant-option__swatch-value');
      var checked = sets[i].querySelector('input:checked');
      if (label && checked && label.textContent !== checked.value) label.textContent = checked.value;
    }
  }

  function syncAll() {
    syncLabels();
    var list = document.querySelectorAll('[data-mm-ral]');
    for (var i = 0; i < list.length; i++) sync(list[i]);
  }

  var scheduled = false;
  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      syncAll();
    });
  }

  // Changement de variante (pastilles / boutons / listes déroulantes) et case « exclusion du droit de rétractation »
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-mm-ack]')) {
      var w = t.closest('[data-mm-ral]');
      if (!updateAckValidity(w)) showAckError(w, '');
      return;
    }
    if (t && t.closest && t.closest('variant-picker')) {
      syncAll();
      scheduleSync();
    }
  });

  // Saisie dans le champ
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-mm-ral-input]')) return;
    var wrapper = t.closest('[data-mm-ral]');
    var msg = updateValidity(wrapper);
    if (!msg) showError(wrapper, '');
  });

  document.addEventListener(
    'blur',
    function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('[data-mm-ral-input]')) return;
      t.value = normalise(t.value);
      updateValidity(t.closest('[data-mm-ral]'));
    },
    true
  );

  // Message visible quand le navigateur bloque l'envoi (événement invalid, ne bouillonne pas)
  document.addEventListener(
    'invalid',
    function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-mm-ack]')) {
        var w = t.closest('[data-mm-ral]');
        showAckError(w, ackMessage(w));
        return;
      }
      if (!t || !t.matches || !t.matches('[data-mm-ral-input]')) return;
      var wrapper = t.closest('[data-mm-ral]');
      showError(wrapper, validity(t.value));
      wrapper.scrollIntoView({ block: 'center', behavior: 'smooth' });
    },
    true
  );

  function formHasRal(form) {
    var inputs = document.querySelectorAll('[data-mm-ral-input]');
    for (var i = 0; i < inputs.length; i++) if (inputs[i].form === form) return true;
    return false;
  }

  function guard(form) {
    if (!form) return true;
    var inputs = document.querySelectorAll('[data-mm-ral-input]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input.form !== form) continue;
      var wrapper = input.closest('[data-mm-ral]');
      sync(wrapper);
      if (input.disabled) continue;
      input.value = normalise(input.value);
      var msg = updateValidity(wrapper);
      if (msg) {
        showError(wrapper, msg);
        wrapper.scrollIntoView({ block: 'center', behavior: 'smooth' });
        input.focus({ preventScroll: true });
        return false;
      }
      var p = parts(wrapper);
      var ackMsg = updateAckValidity(wrapper);
      if (p.ack && ackMsg) {
        showAckError(wrapper, ackMsg);
        p.ack.scrollIntoView({ block: 'center', behavior: 'smooth' });
        p.ack.focus({ preventScroll: true });
        return false;
      }
    }
    return true;
  }

  // Filet de sécurité : bloque l'ajout au panier (clic bouton, barre sticky, envoi du formulaire)
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest && e.target.closest('button[type="submit"], button:not([type]), input[type="submit"]');
      if (!btn || !btn.form) return;
      if (!formHasRal(btn.form)) return;
      if (!guard(btn.form)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      if (!guard(e.target)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true
  );

  // Contenu ajouté ou remplacé (quick-add, rendu de section après changement de variante)
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        scheduleSync();
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
  window.addEventListener('pageshow', syncAll);
})();
